import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"500px"}
}
const _hoisted_4 = { class: "modal__header modal__header--success" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "modal__header--title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-upload" }),
  /*#__PURE__*/_createTextVNode(" Manual Upload ")
], -1)
const _hoisted_6 = {
  class: "modal__content",
  style: {"max-height":"520px"}
}
const _hoisted_7 = { class: "form-field form-field__standard ma--top-1" }
const _hoisted_8 = { class: "form-field__control" }
const _hoisted_9 = {
  type: "file",
  class: "form-field__input",
  ref: "upload"
}
const _hoisted_10 = { style: {"font-size":"80%"} }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("a", {
          class: "fa fa-times modal__header--clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", _hoisted_9, null, 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: _ctx.templateUrl,
            download: "template.csv"
          }, "Download Template", 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn--primary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
        }, " Submit ")
      ])
    ])
  ]))
}